import React from 'react'
import { useField } from 'formik'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons'

import RequestFormValidationError from './ValidationError'
import Label from '../../utils/Label'

const RequestFormStayLength = () => {
  const [fieldStayLength, , { setValue: setFieldStayLength }] = useField('stayLength')

  const label = 'Length of stay (# Nights):'
  return (
    <>
      <Label>{label}</Label>
      <div className="flex">
        <button type="button" className="flex-none pt-1 px-4  border border-gray-300 bg-gray-200 rounded-l-lg disabled:opacity-75" disabled={+fieldStayLength.value === 1} onClick={() => +fieldStayLength.value > 1 && setFieldStayLength(+fieldStayLength.value - 1)}>
          <FontAwesomeIcon icon={faMinus} className={`text-3xl`} />
        </button>
        <input type="number" className="w-24 appearance-none text-2xl p-2 pl-4 border-t border-b border-gray-300" {...fieldStayLength} />
        <button type="button" className="flex-none pt-1 px-4 border border-gray-300  bg-gray-200 rounded-r-lg disabled:opacity-75" disabled={+fieldStayLength.value === 14}  onClick={() => +fieldStayLength.value < 14 && setFieldStayLength(+fieldStayLength.value + 1)}>
          <FontAwesomeIcon icon={faPlus} className={`text-3xl`} />
        </button>
      </div>
      <RequestFormValidationError name="stayLength" />
    </>
  )
}
export default RequestFormStayLength
